import {Offcanvas, OffcanvasGravity} from "../../offcanvas/Offcanvas";
import {useEffect, useState} from "react";
import Axios from "axios";
import {API, ENDPOINTS} from "../../../network/API";
import Rosetta from "../../../rosetta/Rosetta";
import {PlaceholderText} from "../../placeholder/PlaceholderText";
import WindowUtil from "../../../util/WindowUtil";
import {FilterText} from "../../filter/FilterText";

export const ClientSelectionModal = (props) => {

    const {shown} = props;
    const {gravity} = props;

    const [clients, setClients] = useState([]);
    const [clientCount, setClientCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [keyword, setKeyword] = useState("");

    const [clientNetworkInFlight, setClientNetworkInFlight] = useState(false);

    const [callbackData, setCallbackData] = useState(null);
    const [forceDismiss, setForceDismiss] = useState(false);

    useEffect(() => {
        if (shown) {
            WindowUtil.lockBodyScroll();
            getUsersFromNetwork();
        } else {
            WindowUtil.unlockBodyScroll();
            setClients([]);
            setClientCount(0);
            setCurrentPage(1);
            setKeyword("");
            setForceDismiss(false);
            setCallbackData(null);
        }
    }, [shown]);

    useEffect(() => {
        getUsersFromNetwork();
    }, [currentPage]);

    useEffect(() => {
        setClients([]);
        setClientCount(0);
        if (currentPage > 1) {
            setCurrentPage(1);
        } else {
            getUsersFromNetwork();
        }
    }, [keyword]);

    function handleCallback(action) {
        if (props.callback !== undefined) {
            props.callback(action, callbackData);
        }
    }

    function selectUser(user) {
        setCallbackData(user);
        setForceDismiss(true);
    }

    function getUsersFromNetwork() {
        if (!shown || clientNetworkInFlight) return;
        setClientNetworkInFlight(true);

        let formData = {
            keyword,
            page : currentPage
        };

        Axios.post(ENDPOINTS.client.getClients, formData)
            .then((r) => {
                let resp = API.parse(r);
                if (resp.success) {
                    let newClients = [...clients];
                    for (let i = 0; i < resp.data.clients.length; i++) {
                        newClients.push(resp.data.clients[i]);
                    }

                    setClients(newClients);
                    setClientCount(resp.data.count);
                } else {
                    // TODO Error?
                }
                setClientNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                // TODO Error?
                setClientNetworkInFlight(false);
            });
    }

    if (!shown) return [];

    let clientContent = [];
    if (clients.length > 0) {
        for (let i = 0; i < clients.length; i++) {
            clientContent.push(
                <span className="list-group-item clickable" onClick={() => selectUser(clients[i])}>{clients[i].company_name}</span>
            )
        }
    }

    let loadMoreButton = [];

    if (clientCount > clients.length) {
        loadMoreButton = (
            <div className={"row mt-4"}>
                <div className={"col-12 text-center"}>
                    <button className={"btn btn-primary"} onClick={() => setCurrentPage(currentPage + 1)}>{Rosetta.string("common.load_more")}</button>
                </div>
            </div>
        );
    }

    if (clientNetworkInFlight) {
        loadMoreButton = [];

        for (let i = 0; i < 3; i++) {
            clientContent.push(
                <span className="list-group-item">
                    <PlaceholderText />
                </span>
            )
        }
    }

    if (clientContent.length > 0) {
        clientContent = (
            <div className="list-group">
                {clientContent}
            </div>
        );
    } else {
        clientContent = (
            <div className={"empty-message"}>{Rosetta.string("common.empty_message")}</div>
        );
    }

    return (
        <Offcanvas
            title={Rosetta.string("clients.list_title")}
            shown={true}
            gravity={(gravity !== undefined) ? gravity : OffcanvasGravity.END}
            forceDismiss={forceDismiss}
            callback={handleCallback}>

            <div className={"row"}>
                <div className={"col-12"}>
                    <FilterText callback={setKeyword} />
                </div>
            </div>

            <div className={"row mt-4"}>
                <div className={"col-12"}>
                    {clientContent}
                </div>
            </div>

            {loadMoreButton}

        </Offcanvas>
    )
}